import Home from "./Home";

const routes = [{ path: "/", component: <Home /> }];

export default routes;
